const Intro = () => import('@pages/Intro')
const IntroMain = () => import('@pages/Intro/Main')
const Program = () => import('@pages/Intro/Program')
const ProgramShow = () => import('@pages/Program/Show')
const SignUp = () => import('@pages/Intro/SignUp')
const ProgramUser = () => import('@pages/Intro/ProgramUser')
const Hotel = () => import('@pages/Intro/Hotel')

import {checkLocalStorage} from '@utils/api'
import {isWechatBrower, getAuthorizeUrl2} from '@utils/wx'
import {WECHAT_OPEN_ID} from '@store/mutation-types'

export const intro = [
  {
    path: '/intro',
    component: Intro,
    meta: {auth: false},
    children: [
      {
        path: '',
        name: 'IntroMain',
        component: IntroMain,
        meta: {auth: false, title: '首页', hideBack: true}
      },
      {
        path: '/programs',
        name: 'Program',
        component: Program,
        meta: {auth: false, title: '岗位培训列表', hideBack: true}
      },
      {
        path: '/programs/:programId',
        name: 'ProgramShow',
        component: ProgramShow,
        meta: {auth: false, title: '培训详情', hideBack: true}
      },
      {
        path: '/sign_up',
        name: 'SignUp',
        component: SignUp,
        meta: {auth: false, title: '报名', hideBack: true},
        beforeEnter: (to, from, next) => {
          if (!checkLocalStorage(WECHAT_OPEN_ID) && isWechatBrower()) {
            localStorage.setItem('leave_app_route', 'SignUp')
            window.location.href = getAuthorizeUrl2()
          } else {
            next()
          }
        }
      },
      {
        path: '/program_user',
        name: 'ProgramUser',
        component: ProgramUser,
        meta: {auth: false, title: '学员信息', hideBack: true},
        beforeEnter: (to, from, next) => {
          if (!checkLocalStorage(WECHAT_OPEN_ID) && isWechatBrower()) {
            localStorage.setItem('leave_app_route', 'ProgramUser')
            window.location.href = getAuthorizeUrl2()
          } else {
            next()
          }
        }
      },
      {
        path: '/hotels/:id',
        name: 'Hotel',
        component: Hotel,
        meta: {auth: false, title: '合作酒店', hideBack: true},
        beforeEnter: (to, from, next) => {
          if (!checkLocalStorage(WECHAT_OPEN_ID) && isWechatBrower()) {
            localStorage.setItem('leave_app_route', 'Hotel')
            window.location.href = getAuthorizeUrl2()
          } else {
            next()
          }
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/mod/intro.route.js